import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from "react-oidc-context";
import ProtectedRoute from './ProtectedRoute';

// Define OneLogin Configuration
const oidcConfig = {
    authority: "https://copadata.onelogin.com/oidc/2",
    client_id: "d8ddaea0-e95c-013e-0cd5-0cfbd7b3658c38555", // Replace with your real Client ID
    redirect_uri: window.location.origin,
    // redirect_uri: "http://localhost:3002", // Ensure this matches OneLogin Portal settings exactly
    response_type: "code",
    scope: "openid profile email params",
    // This automatically renews the token so the user doesn't get logged out - if true
    automaticSilentRenew: false,
};

const onSigninCallback = (_user) => {
    // Entfernt ?code=...&state=... aus der Adressleiste, ohne die Seite neu zu laden
    window.history.replaceState({}, document.title, window.location.pathname);
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <AuthProvider {...oidcConfig}>
          <ProtectedRoute>
              <App />
          </ProtectedRoute>
      </AuthProvider>
    {/*<App />*/}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
